import { render, staticRenderFns } from "./wgModeNew.vue?vue&type=template&id=1206b4b0&scoped=true&"
import script from "./wgModeNew.vue?vue&type=script&lang=js&"
export * from "./wgModeNew.vue?vue&type=script&lang=js&"
import style0 from "./wgModeNew.vue?vue&type=style&index=0&id=1206b4b0&lang=scss&scoped=true&"
import style1 from "./wgModeNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206b4b0",
  null
  
)

export default component.exports